<ng-container *ngIf="types.length">

  <app-specification-painel [title]="title" [total]="types.length" [error]="forms.invalid">

    <ng-container *ngFor="let form of forms.controls; let index = index">

      <form [formGroup]="form" fxLayout="row" fxLayoutGap="8px">
        <h4 fxFlex="25">{{title}} {{index + 1 | number:'2.0-0'}}</h4>

        <mat-form-field fxFlex appearance="outline">
          <mat-label i18n>Derivation Ports</mat-label>
          <input type="number" matInput formControlName="cable_ports">
        </mat-form-field>

        <mat-form-field fxFlex appearance="outline">
          <mat-label i18n>Splicing capacity</mat-label>
          <input type="number" matInput formControlName="max_fusions">
        </mat-form-field>

        <mat-form-field fxFlex appearance="outline" *ngIf="form.get('max_splitters')">
          <mat-label i18n>Splitters capacity</mat-label>
          <input type="number" matInput formControlName="max_splitters">
        </mat-form-field>

        <mat-form-field fxFlex appearance="outline" *ngIf="form.get('customer_ports')">
          <mat-label i18n>Customer ports</mat-label>
          <input type="number" matInput formControlName="customer_ports">
        </mat-form-field>

        <mat-form-field fxFlex appearance="outline" *ngIf="form.get('bus_ports')">
          <mat-label i18n>Bus ports</mat-label>
          <input type="number" matInput formControlName="bus_ports">
        </mat-form-field>

      </form>
      <div fxLayout="row" *ngIf="form.get('cable_ports').errors?.min">
        <mat-error i18n fxFlex fxFlexOffset="25">Derivation Ports must be at least 2</mat-error>
      </div>

    </ng-container>

  </app-specification-painel>
</ng-container>
